import React, { useState, useRef } from 'react';
import usePortal from '../../hooks/usePortal';
import { get_data_by_current_language } from '../../utils/GetDataByLanguage';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import ReadingComposer from '../Shared/Composer/ReadingComposer';
import AllIcons from '../Shared/Constant/Icons/AllIcons';

const ButtonWithModal = ({ data, styles, rules }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const Portal = usePortal();
  const modalRef = useRef(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleOverlayClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      closeModal();
    }
  };

  const handleEscapeKey = (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  };

  React.useEffect(() => {
    if (isModalOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isModalOpen]);

  return (
    <>
      <div style={get_dynamic_styles(styles?.main_styles)}>
        <button
          onClick={openModal}
          style={get_dynamic_styles(styles?.button_styles)}
        >
          {get_data_by_current_language({
            data_list: data?.translated_data,
            key_name: 'button_title',
            default_data: data?.button_title,
          })}
        </button>
      </div>

      {isModalOpen && (
        <Portal>
          <div
            className="fixed inset-0 flex items-center justify-center p-4 bg-black bg-opacity-50"
            style={{ pointerEvents: 'auto' }}
            onClick={handleOverlayClick}
          >
            <div
              className="w-full h-full overflow-y-auto overflow-x-auto  "
              style={get_dynamic_styles(styles?.modal_box_styles)}
              ref={modalRef}
            >
              {/* Close Button */}
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 z-10 p-2 text-primary hover:text-primary transition-colors"
                aria-label="Close modal"
              >
                {AllIcons.close_icon}
              </button>

              {/* Description */}
              <ReadingComposer
                contents={get_data_by_current_language({
                  data_list: data?.translated_data,
                  key_name: 'description',
                  default_data: data?.description,
                })}
              />
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default ButtonWithModal;
